var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "main",
    },
    [
      _c(
        "el-scrollbar",
        { ref: "scrollbar", staticStyle: { height: "100%" } },
        [
          _c("div", { staticClass: "header clearfix" }, [
            _c("div", { staticClass: "qrcode-box" }, [
              _c("div", { ref: "qrcode", attrs: { id: "qrcode" } }),
            ]),
            _c(
              "div",
              { staticClass: "hright" },
              [
                _c("h2", [
                  _vm._v(
                    " " + _vm._s(_vm.companyStatus.nickName || "--") + " "
                  ),
                ]),
                _vm.companyStatus.source || _vm.companyStatus.constellation
                  ? _c("div", { staticClass: "tags mt-15" }, [
                      _vm.companyStatus.source
                        ? _c("span", { staticClass: "tag platform" }, [
                            _vm._v(
                              _vm._s(
                                _vm.companyStatus.source === "douyin"
                                  ? "DY"
                                  : "KS"
                              )
                            ),
                          ])
                        : _vm._e(),
                      _vm.companyStatus.constellation !== "0" &&
                      _vm.companyStatus.constellation !== null
                        ? _c("span", { staticClass: "tag constellation" }, [
                            _vm._v(
                              _vm._s(
                                _vm.constellation(
                                  _vm.companyStatus.constellation
                                )
                              )
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c(
                  "el-row",
                  { staticClass: "mt-15" },
                  [
                    _c("p", [
                      _vm._v("询盘账号： "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.companyStatus.uniqueId || "--")),
                      ]),
                    ]),
                    _c("p", [
                      _vm._v("评论时间： "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$moment(_vm.companyStatus.createTime * 1000)
                              .format("YYYY-MM-DD") || "--"
                          )
                        ),
                      ]),
                    ]),
                    _c("p", [
                      _vm._v("评论点赞数： "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.companyStatus.awemeCount || "0")),
                      ]),
                    ]),
                    _vm.companyStatus.signature &&
                    _vm.companyStatus.signature.length > 25
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.companyStatus.signature,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                  width: "80%",
                                },
                              },
                              [
                                _vm._v("签名： "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.companyStatus.signature)),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _c(
                          "p",
                          {
                            staticStyle: {
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              width: "80%",
                            },
                          },
                          [
                            _vm._v("签名： "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.companyStatus.signature || "--")
                              ),
                            ]),
                          ]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticStyle: { height: "20px", background: "#f1f2f4" } }),
          _c(
            "div",
            { staticClass: "card-inquiry-data" },
            [
              _c(
                "el-row",
                { attrs: { span: 24 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [_vm._v("询盘数据")]),
                  _c(
                    "el-col",
                    { staticClass: "card-data-info", attrs: { span: 24 } },
                    [
                      _c(
                        "p",
                        [
                          _vm._v("视频源地址： "),
                          _vm.companyStatus.comDesc &&
                          _vm.companyStatus.comDesc.length > 35
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.companyStatus.comDesc,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "a-blue",
                                      attrs: {
                                        href: _vm.companyStatus.videoUrl,
                                        referrerpolicy: "no-referrer",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.companyStatus.comDesc))]
                                  ),
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "a-blue",
                                  attrs: {
                                    href: _vm.companyStatus.videoUrl,
                                    referrerpolicy: "no-referrer",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.companyStatus.comDesc || "--")
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c("p", [
                        _vm._v("关键词内容： "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.companyStatus.keyWord || "--")),
                        ]),
                      ]),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            width: "80%",
                            display: "inline-block",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "card-data-inquiry-content" },
                            [_vm._v("询盘内容")]
                          ),
                          _vm.companyStatus.text &&
                          _vm.companyStatus.text.length > 25
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.companyStatus.text,
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.companyStatus.text)),
                                  ]),
                                ]
                              )
                            : _c("span", [
                                _vm._v(_vm._s(_vm.companyStatus.text || "--")),
                              ]),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "20px", background: "#f1f2f4" } }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }